import { Model } from 'pinia-orm'
import { Num, Str } from 'pinia-orm/decorators'

export default class Club extends Model {
    static entity = 'clubs'

    @Num( 0, { notNullable: true } ) declare id: number
    @Str( '', { notNullable: true } ) declare name: string
    @Str( null ) declare shortcut: string | null
    @Str( null ) declare street: string | null
    @Str( null ) declare city: string | null
    @Str( null ) declare zip: string | null
    @Str( null ) declare manager: string | null
    @Str( null ) declare email: string | null

    static piniaOptions = {
        persist: true
    }

    get fullName () {
        return this.id + ' ' + this.name
    }

    isSameRegion ( clubId ) {
        if ( parseInt( String( this.id ).substring( 0, 2 ) ) >= 60 || parseInt( String( clubId ).substring( 0, 2 ) ) >= 60 )
            return false

        const regions = new Map( [
            [ '11', 11 ], [ '12', 11 ],
            [ '13', 13 ],
            [ '14', 14 ], [ '15', 14 ],
            [ '16', 16 ], [ '17', 16 ],
            [ '20', 20 ], [ '21', 20 ],
            [ '22', 22 ], [ '23', 22 ],
            [ '24', 24 ]
        ] )

        if ( !regions.has( String( this.id ).substring( 0, 2 ) ) || !regions.has( String( clubId ).substring( 0, 2 ) ) )
            return false

        return regions.get( String( this.id ).substring( 0, 2 ) ) === regions.get( String( clubId ).substring( 0, 2 ) )
    }

    isSameDistrict ( clubId ) {
        if ( parseInt( String( this.id ).substring( 0, 2 ) ) >= 60 || parseInt( String( clubId ).substring( 0, 2 ) ) >= 60 )
            return false

        return String( this.id ).substring( 0, 2 ) === String( clubId ).substring( 0, 2 )
    }
}